(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("erichsia7", [], factory);
	else if(typeof exports === 'object')
		exports["erichsia7"] = factory();
	else
		root["erichsia7"] = factory();
})(self, () => {
return 